import React from 'react';
import { translate } from '../utils/Common';
import { cn } from '@/lib/utils';

/**
 * Loading indicator used across 67 files.
 *
 * The API is unchanged (`type` picks the variant, `size` is a pixel value), but
 * it no longer relies on Bootstrap's `.spinner-border` / `.spinner-grow`, which
 * would disappear with Bootstrap. It inherits the current text colour, so it
 * works on both light and dark surfaces and inside coloured buttons.
 */
const Spinner = ({ type, size = 20, className }) => {
    const label = translate("global.loading");
    const dimension = { width: size, height: size };

    if (type) {
        return (
            <div
                role="status"
                style={dimension}
                className={cn(
                    'inline-block animate-spin rounded-full border-2 border-current border-r-transparent align-[-0.125em]',
                    className
                )}
            >
                <span className="sr-only">{label}</span>
            </div>
        );
    }

    return (
        <div
            role="status"
            style={dimension}
            className={cn(
                'inline-block animate-ping rounded-full bg-current opacity-75',
                className
            )}
        >
            <span className="sr-only">{label}</span>
        </div>
    );
}

export default Spinner;
